import { ReactComponent as IconChevronDown } from "@/assets/svgs/chevron-down.svg";
import classname from 'classnames';
import PropTypes from 'prop-types';
import { useRef, useState } from "react";

const HorizontalCarousel = ({ children, ...props }) => {
	const [scrollPos, setScrollPos] = useState(0);
	const contentRef = useRef(null);
	const holderRef = useRef(null);
	const handleRightClick = () => {
		if (contentRef.current) {
			const containerWidth = contentRef.current?.scrollWidth - contentRef.current?.offsetWidth;
			const newScrollPos = scrollPos - 100;
			setScrollPos(Math.abs(newScrollPos) > containerWidth ? -containerWidth : newScrollPos);
		}
	};

	const handleLeftClick = () => {
		const newScrollPos = scrollPos + 100;
		setScrollPos(newScrollPos > 0 ? 0 : newScrollPos);
	};

	const horizontal_carousel__body = classname({
		"horizontal_carousel__body": true,
		"horizontal_carousel__body__right_border": scrollPos - holderRef.current?.offsetWidth + contentRef.current?.scrollWidth > 0,
		"horizontal_carousel__body__left_border": scrollPos !== 0,
	})

	return (
		<div className="horizontal_carousel" {...props}>
			<div
				className="horizontal_carousel__pointer horizontal_carousel__button left"
				data-testid="horizontal_carousel__left_button"
				onClick={handleLeftClick}
			>
				<IconChevronDown />
			</div>
			<div className={horizontal_carousel__body} ref={holderRef}>
				<div
					className="horizontal_carousel__body__container"
					data-testid="horizontal_carousel__body__container"
					style={{ transform: `translateX(${scrollPos}px)` }}
					ref={contentRef}
				>
					{children}
				</div>
			</div>
			<div
				className="horizontal_carousel__pointer horizontal_carousel__button right"
				data-testid="horizontal_carousel__right_button"
				onClick={handleRightClick}
			>
				<IconChevronDown />
			</div>
		</div>
	)
}

HorizontalCarousel.propTypes = {
	children: PropTypes.node.isRequired,
}

export default HorizontalCarousel;
